import { AxiosInstance } from "axios";
import { RequestUtils } from "../../../utils/requestUtils";

export const registerParamsInterceptor = (axiosClient: AxiosInstance) => {
  axiosClient.interceptors.request.use(async (request) => {
    const params = { ...request.params };
    request.params = RequestUtils.parseParams(params);
    request.paramsSerializer = { indexes: null };
    return request;
  });
};
